import React from 'react';

const Banner = () => {
    
    return (
        <div>
            <div class="hero min-h-screen px-8">
                <div class="hero-content flex-col lg:flex-row-reverse">
                    <img src="https://cdn.searchenginejournal.com/wp-content/uploads/2021/09/top-14-benefits-of-social-media-for-your-business-1-615db39f4542c-sej-1520x800.png" alt='tesla-car' class="max-w-sm rounded-lg shadow-2xl" />
                    <div>
                        <h1 class="text-5xl font-bold">Everyone says social media is a unicorn, but maybe its just a horse.</h1>
                        <p class="py-6">The scope of Social Media becomes crucial as it helps the business to directly engage with their needs and wants. One of the biggest benefits of social media for businesses is using it to increase your website traffic.</p>
                        <button class="btn bg-gradient-to-r from-primary to-secondary border-primary  text-white font-bold">Get Started</button>
                    </div>
                </div>
            </div>
          
        </div>
    );
};

export default Banner;